// extracted by mini-css-extract-plugin
export default {"callIcon":"CallItem_callIcon__kUYVC"};